import React from "react";
import { Box, Modal } from "@mui/material";
import modalStyle from "../../assets/jss/material-dashboard-react/components/modalStyle";

export default function CustomModal(props) {
    const { open, handleClose, children } = props;

    return (
        <Modal open={open} onClose={handleClose}>
            <Box color="primary" sx={modalStyle.root}>
                {children}
            </Box>
        </Modal>
    );
}
